import './Footer.css'; // Import your CSS file
import React, { useState, useEffect } from 'react';
import './BackToTopButton.css'; // You can create a CSS file for styling

function BackToTopButton() {
    const [isVisible, setIsVisible] = useState(true);
  
    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 300) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };
  
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
  
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
  
    return (
        <div        className={`back-to-top-button ${isVisible ? 'visible' : ''}`}
        onClick={scrollToTop}>
      <span // Use a <span> element instead of <button> for plain text appearance

      >
        Back to top

      </span>
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-narrow-up" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M12 5l0 14"></path>
              <path d="M16 9l-4 -4"></path>
              <path d="M8 9l4 -4"></path>
           </svg>
           </div>

    );
  }


function Footer() {
  const HEIGHT = {height: '70px'}
  return (
    <footer>
            <div class="footer-line"></div>
            <div class="footer-wrapper">
                <div class="footer-logos">
                    <section class="footer-logo">
                    <div class="logo-scroll-container">
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/mathworks-logo-one-color-reversed.svg"} alt="Logo 1"/>
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/new-ingland-inverted.gif"} alt="Logo 2"/>
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/snapgene-logo.png"} alt="Logo 3"/>
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/sponsor-idt.svg"} alt="Logo 4"/>
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/twist-bioscience-blacklogo.jpg"} alt="Logo 5"/>
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/beckman-coulter-inverted.png"} alt="Logo 6"/>
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/bioconvs-sponsor.png"} alt="Logo 6"/>
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/upc-png.png"} alt="Logo 6"/>
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/lpi-logo.png"} alt="Logo 6"/>
                        <img {...HEIGHT} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/inserm-rvb-blanc.png"} alt="Logo 6"/>
                        <img {...HEIGHT} style={{backgroundColor: '#efecec', borderRadius: '3px'}} src={"https://static.igem.wiki/teams/4602/wiki/images/sponsors/fondation-bs.png"} alt="Logo 6"/>
                    </div>
                    </section>
                </div>
                <div class="footer-bottom">
                    <div class='social-links'>
                        <ul>
                            <li>
                                <a href="https://www.instagram.com/bettencourt.igem/" title="Instagram">
                                    <img {...HEIGHT}  src="https://static.igem.wiki/teams/4602/wiki/images/social/instagram.svg" alt='Instagram'/>                       
                                </a>
                            </li>
                        </ul>

                    </div>
                   <p>© 2023 - Content on this site is licensed under a <a href="https://creativecommons.org/licenses/by/4.0/">Creative Commons Attribution 4.0 International license</a></p>
<p>The repository used to create this website is available at <a href="https://gitlab.igem.org/2023/paris-bettencourt">gitlab.igem.org/2023/paris-bettencourt</a></p>
                    <small>© Lubritect <span id="year">2023</span></small>
                    <BackToTopButton/>
                </div>
            </div>
    </footer>
  );
}

export default Footer;
